import React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  ButtonGroup,
  Grid
} from "@material-ui/core";
import styles from "./ListCategoriesPage.module.scss";
import { HeaderBlock } from "../../../components/header-block/HeaderBlock";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  addCategory,
  removeCategories,
  getCategories
} from "../../../state/actions/CategoryActions";
import { PagePlaceholder } from "../../../components/page-placeholder/PagePlaceholder";
import SimpleTable from "../../../components/table/Table";
import AlertDialog from "../../../components/alert-dialog/AlertDialog";
import { getIcon } from "../../../icon/icon";
import { Loading } from "../../../components/loading/Loading";
import { NewEntityDialog } from "../../../containers/new-entity-dialog/NewEntityDialog";
import PageContainer from "../../../components/page-container/PageContainer";
import Search from "../../../components/search/Search";
import { withTranslation } from "react-i18next";

class ListCategoriesPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      newCategoryText: "",
      addCategoryModalOpen: false,
      originalData: [],
      searchedData: [],
      loading: false,
      categories: props.categories,
      selectedCategoryIds: [],
      deleteAlertShowing: false
    };
  }

  componentDidMount() {
    this.setupData();
  }

  componentDidUpdate() {
    if (
      JSON.stringify(this.state.categories) !==
      JSON.stringify(this.props.categories)
    ) {
      const data = this.createData(this.props.categories);

      this.setState({
        originalData: data,
        searchedData: data,
        categories: this.props.categories
      });
    }
  }

  setupData() {
    this.setState({ loading: true });

    this.props.getCategories(() => {
      const data = this.createData(this.props.categories);

      this.setState({
        loading: false,
        originalData: data,
        searchedData: data,
        categories: this.props.categories
      });
    });
  }

  createData(categories) {
    const categoryKeys = Object.keys(categories);

    return categoryKeys.map(categoryKey => {
      const category = categories[categoryKey];

      return {
        categoryId: categoryKey,
        Name: category.Name
      };
    });
  }

  createHeaders() {
    return [
      {
        id: "Name",
        clickable: true,
        action: { path: "/categories/{id}", identifier: "categoryId" },
        align: "left",
        label: this.props.t('category.category-name')
      },
      {
        id: "categoryId",
        clickable: false,
        align: "left",
        label: this.props.t('category.category-id')
      }
    ];
  }

  createCells(headers) {
    let cells = [];

    headers.forEach(header => {
      let cell = {};

      cell.id = header.id;

      if (header.hasOwnProperty("action")) {
        cell.handleClick = (event, row) => {
          let path = header.action.path.replace(
            "{id}",
            row[header.action.identifier]
          );
          this.props.history.push(path);
        };
      }

      cell.align = header.align;
      cell.clickable = header.clickable;

      cells.push(cell);
    });

    return cells;
  }

  renderData() {
    const headers = this.createHeaders();
    const cells = this.createCells(headers);

    if (this.state.searchedData.length === 0) {
      return (
        <PagePlaceholder
          image={getIcon("layers.svg")}
          text={this.props.t('category.none-found')}
        />
      );
    } else {
      return (
        <SimpleTable
          handleSelection={selectedIds => {
            this.setState({ selectedCategoryIds: selectedIds });
          }}
          isSelectable={true}
          dataId={"categoryId"}
          cells={cells}
          headers={headers}
          rows={this.state.searchedData}
        />
      );
    }
  }

  alertDialog() {
    return (
      <AlertDialog
        title={this.props.t('common.remove-question')}
        description={this.props.t("common.remove-description")}
        options={[
          {
            label: this.props.t('common.cancel'),
            action: () => this.setState({ deleteAlertShowing: false })
          },
          { label: this.props.t('common.delete'), action: () => this.deleteSelection() }
        ]}
        isOpen={this.state.deleteAlertShowing}
      />
    );
  }

  deleteSelection() {
    this.props.removeCategories(this.state.selectedCategoryIds, () => {
      this.setState({ selectedCategoryIds: [], deleteAlertShowing: false });
    });
  }

  render() {

    return (
      <div>
        <NewEntityDialog
          dialogTitle={this.props.t('category.add-category')}
          confirmLabel={this.props.t('category.add-category')}
          isOpen={this.state.addCategoryModalOpen}
          onCancel={() => this.setState({ addCategoryModalOpen: false, newCategoryText: '' })}
          onTitleChange={value => this.setState({ newCategoryText: value })}
          title={this.state.newCategoryText}
          onConfirm={() => {
            this.props.addCategory(
              { Name: this.state.newCategoryText },
              success => {
                let newCategoryText = this.state.newCategoryText;

                if (success) {
                  newCategoryText = "";
                }

                this.setState({ addCategoryModalOpen: false, newCategoryText });
              }
            );
          }}
        />

        {this.alertDialog()}

        <HeaderBlock
          title={this.props.t('category.categories')}
          right={
            <Grid container spacing={2} alignItems="center" justify="flex-end">
              <Grid item>
                <Search
                  searchField={"Name"}
                  secondaryFields={["categoryId"]}
                  returnSearchMatches={data => {
                    this.setState({ searchedData: data });
                  }}
                  data={this.state.originalData}
                  searchTitle={this.props.t('category.search-category')}
                />
              </Grid>
              <Grid item>
                <ButtonGroup>
                  <Button
                    disabled={this.state.selectedCategoryIds.length === 0}
                    onClick={() => this.setState({ deleteAlertShowing: true })}
                    variant="outlined"
                    color="primary"
                  >
                    {this.props.t('common.delete')}
              </Button>
                  <Button
                    onClick={() => this.setState({ addCategoryModalOpen: true })}
                    variant="outlined"
                    color="secondary"
                  >
                    {this.props.t('category.new-category')}
              </Button>
                </ButtonGroup>
              </Grid>
            </Grid>

          }
        />
        <PageContainer hasFooter>
          {this.state.loading ? <Loading /> : this.renderData()}
        </PageContainer>
      </div>
    );
  }
}

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
  const { categories } = state.CategoryReducer;
  return { categories };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { addCategory, removeCategories, getCategories },
    dispatch
  );

const hoc = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ListCategoriesPage))
);

// EXPORT COMPONENT

export { hoc as ListCategoriesPage };
